import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "benefits-area pt-100" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  class: "col-xl-6",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}
const _hoisted_5 = { class: "benefits-img" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "review mb-minus-53" }
const _hoisted_8 = { class: "review-in" }
const _hoisted_9 = { class: "stat-figure stat-figure-light" }
const _hoisted_10 = { class: "col-xl-6" }
const _hoisted_11 = { class: "benefits-content" }
const _hoisted_12 = { class: "top-title" }
const _hoisted_13 = { class: "text-white" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = ["data-aos-delay"]
const _hoisted_16 = { class: "d-flex benefits-single-item" }
const _hoisted_17 = { class: "flex-shrink-0" }
const _hoisted_18 = { class: "flex-grow-1 ms-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _ctx.c.image_url || _ctx.benefitsImg,
              alt: "benefits"
            }, null, 8, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[0] || (_cache[0] = _createElementVNode("span", null, "EXPERIENCE OF", -1)),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.c.experience_years) + " Yrs", 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.c.top_title), 1),
            _createElementVNode("h2", _hoisted_13, _toDisplayString(_ctx.c.title), 1),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.c.items, (benefit, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "col-lg-6",
                  "data-aos": "fade-up",
                  "data-aos-duration": "1000",
                  "data-aos-delay": 200 + (index % 2) * 100
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("i", {
                        class: _normalizeClass(benefit.icon)
                      }, null, 2)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("h3", null, _toDisplayString(benefit.title), 1),
                      _createElementVNode("p", null, _toDisplayString(benefit.description), 1)
                    ])
                  ])
                ], 8, _hoisted_15))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}